export default __webpack_public_path__ + "static/media/H1005.4.54739a83.mp3";